/* FAETTON FINAL POLISH V5 — targeted fixes only:
   1) keep Kaching untouched; use placeholder only while empty, never delay app execution
   2) Quick Add / upsell variant image + dots sync + active swatch state
   3) search opens in one tap and preserves scroll position
   4) mobile PDP blocks only obvious load-time top jumps; no repeated scroll restore
*/
(function(){
  'use strict';
  var win = window;
  var doc = document;
  var html = doc.documentElement;
  var isProduct = function(){ return ((html.getAttribute('data-template') || '').indexOf('product') !== -1) || /\/products\//.test(location.pathname); };
  var isMobile = function(){ return win.matchMedia ? win.matchMedia('(max-width: 767px)').matches : win.innerWidth <= 767; };

  /* -------------------------------------------------------------------------- */
  /* Gentle scroll guard + fast search. No continuous restore, no scroll fighting. */
  /* -------------------------------------------------------------------------- */
  (function gentleScrollGuardAndSearch(){
    var lastTouchY = 0;
    var lastWheelY = 0;
    var protectTopUntil = isProduct() ? (Date.now() + 4500) : 0;
    var savedSearchY = null;
    var openedSearchAt = 0;

    function currentY(){ return win.pageYOffset || doc.documentElement.scrollTop || doc.body.scrollTop || 0; }
    function noteUserIntent(){
      if(!isMobile()) return;
      var y = currentY();
      lastTouchY = y;
      lastWheelY = y;
      if(isProduct()) protectTopUntil = Date.now() + 3000;
    }
    win.addEventListener('touchstart', noteUserIntent, {passive:true, capture:true});
    win.addEventListener('pointerdown', noteUserIntent, {passive:true, capture:true});
    win.addEventListener('wheel', noteUserIntent, {passive:true, capture:true});

    function argsWantTop(args){
      if(!args || !args.length) return false;
      if(typeof args[0] === 'object' && args[0]) return Number(args[0].top || 0) <= 4;
      return Number(args[1] || 0) <= 4;
    }

    // Only blocks obvious programmatic jumps to top during PDP boot.
    // It does NOT restore repeatedly and does NOT block normal touch scrolling.
    try{
      win.__faettonNativeScrollTo = win.__faettonNativeScrollTo || win.scrollTo.bind(win);
      var nativeScrollTo = win.__faettonNativeScrollTo;
      win.scrollTo = function(){
        if(isMobile() && isProduct() && Date.now() < protectTopUntil && argsWantTop(arguments)){
          var y = currentY();
          var userY = Math.max(lastTouchY || 0, lastWheelY || 0);
          if(userY > 80 || y > 80) return;
        }
        return nativeScrollTo.apply(win, arguments);
      };
    }catch(e){}

    function isSearchTrigger(target){
      return target && target.closest && target.closest('[data-header-search], .mobile_search_btn, .search-click a, a.icon-search.dropdown_link, a[href="#search"], button[aria-label*="search" i], button[aria-label*="buscar" i]');
    }
    function restoreSearchYOnce(){
      if(savedSearchY === null) return;
      var y = savedSearchY;
      // One single correction only, and only if a legacy search handler jumped to top.
      if(y > 24 && currentY() < Math.max(12, y - 100)) {
        try { (win.__faettonNativeScrollTo || win.scrollTo).call(win, 0, y); } catch(e){ try{ win.scrollTo(0, y); }catch(err){} }
      }
    }
    function openSearchFast(target, ev){
      if(!isSearchTrigger(target)) return false;
      var now = Date.now();
      if(now - openedSearchAt < 180) return true;
      openedSearchAt = now;
      savedSearchY = currentY();
      var isInput = target && target.matches && target.matches('input,textarea');
      if(ev && !isInput){ try{ ev.preventDefault(); }catch(e){} }
      try{
        var drawer = doc.querySelector('.drawer--cart');
        if(drawer) drawer.classList.add('showsearch');
        var btn = target.closest && target.closest('.mobile_search_btn');
        if(btn && btn.nextElementSibling) btn.nextElementSibling.classList.remove('hidden');
        var searchWrap = doc.querySelector('.header-mobile__searchbar__container, .header-desktop__searchbar__container, .search-modal');
        if(searchWrap) searchWrap.classList.remove('hidden','hide');
        var input = doc.querySelector('.drawer--cart.showsearch input[type="search"], .drawer--cart.showsearch input[name="q"], .header-mobile__searchbar__input, .header-desktop__searchbar__input, .search-modal input[name="q"]');
        if(input) setTimeout(function(){ try{ input.focus({preventScroll:true}); }catch(e){ try{ input.focus(); }catch(err){} } restoreSearchYOnce(); }, 30);
      }catch(e){}
      setTimeout(restoreSearchYOnce, 60);
      setTimeout(function(){ savedSearchY = null; }, 400);
      return true;
    }
    doc.addEventListener('pointerdown', function(e){ openSearchFast(e.target, null); }, {passive:true, capture:true});
    doc.addEventListener('click', function(e){ openSearchFast(e.target, e); }, true);
  })();

  /* -------------------------------------------------------------------------- */
  /* Kaching untouched: do not delay app; show temporary skeleton only if empty. */
  /* -------------------------------------------------------------------------- */
  (function kachingSkeletonOnly(){
    if(!isProduct()) return;
    function hasRealContent(el){
      if(!el) return false;
      var txt = (el.textContent || '').replace(/\s+/g,'');
      return (el.children && el.children.length > 0 && txt.length > 1) || txt.length > 6;
    }
    function attach(el){
      if(!el || el.__faettonKachingSkeletonDone) return;
      el.__faettonKachingSkeletonDone = true;
      if(hasRealContent(el)) return;
      var sk = doc.createElement('div');
      sk.className = 'faetton-kaching-skeleton';
      sk.setAttribute('aria-hidden','true');
      try { el.parentNode && el.parentNode.insertBefore(sk, el); } catch(e) { return; }
      function cleanup(){
        if(hasRealContent(el) && sk && sk.parentNode){ sk.parentNode.removeChild(sk); }
      }
      var mo = new MutationObserver(cleanup);
      try{ mo.observe(el, {childList:true, subtree:true, characterData:true}); }catch(e){}
      setTimeout(cleanup, 100);
      setTimeout(cleanup, 600);
      setTimeout(function(){ cleanup(); try{ mo.disconnect(); }catch(e){} if(sk && sk.parentNode) sk.parentNode.removeChild(sk); }, 4200);
    }
    function scan(){
      qsa(doc, 'kaching-bundle, kaching-bundles, .kaching-bundles, .kaching-bundles__block').forEach(attach);
    }
    function qsa(root, sel){ return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
    if(doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', scan, {once:true}); else scan();
    setTimeout(scan, 200);
    setTimeout(scan, 800);
  })();

  /* -------------------------------------------------------------------------- */
  /* Quick Add / upsell sliders: variant image + dots sync.                      */
  /* -------------------------------------------------------------------------- */
  (function upsellVariantSliderFix(){
    function qsa(root, sel){ return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
    function closest(el, sel){ return el && el.closest ? el.closest(sel) : null; }
    function normUrl(url){
      if(!url) return '';
      var s = String(url).split('?')[0].replace(/^https?:/, '').toLowerCase();
      s = s.replace(/_(\d+x\d+|\d+x|x\d+|small|medium|large|compact|grande|master)(?=\.)/g, '');
      s = s.replace(/\/cdn\/shop\/products\//, '/products/');
      return s;
    }
    function fileBase(url){
      var s = normUrl(url);
      var p = s.split('/');
      return p[p.length - 1] || s;
    }
    function findSliderScope(el){
      return closest(el, '.flyout-section, .upsell-popup, .prod_flyout-radous, .prod-content') || doc;
    }
    function getSliders(scope){ return qsa(scope, '.image-slider, [id^="quick-add-slider"]'); }
    function getSlides(slider){
      var slides = qsa(slider, '.splide__slide');
      if(!slides.length) slides = qsa(slider, '.slider-item');
      return slides;
    }
    function getList(slider){ return slider.querySelector('.splide__list') || slider.querySelector('.slider-container') || slider.querySelector('.splide__track'); }
    function getTrack(slider){ return slider.querySelector('.splide__track') || slider.querySelector('.slider-container') || slider; }
    function updateDots(slider, index){
      var dots = qsa(slider, '.splide__pagination__page, .dots-inner .dot');
      if(!dots.length) return;
      var maxVisible = Math.min(7, dots.length);
      var start = 0;
      if(dots.length > maxVisible) start = Math.max(0, Math.min(index - 3, dots.length - maxVisible));
      dots.forEach(function(dot, i){
        var active = i === index;
        var hidden = dots.length > maxVisible && (i < start || i >= start + maxVisible);
        dot.classList.toggle('is-active', active);
        dot.classList.toggle('active', active);
        dot.classList.toggle('faetton-dot-hidden', hidden);
        if(dot.parentElement && dot.parentElement.tagName === 'LI') dot.parentElement.classList.toggle('faetton-dot-hidden', hidden);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
    function ensureDots(slider){
      var slides = getSlides(slider);
      if(slides.length < 2) return;
      var dotsInner = slider.querySelector('.dots-inner');
      if(dotsInner && !dotsInner.children.length) {
        slides.forEach(function(_, i){
          var dot = doc.createElement('span');
          dot.className = 'dot' + (i === 0 ? ' active' : '');
          dot.setAttribute('role','button');
          dot.setAttribute('aria-label','Ir para imagem ' + (i + 1));
          dot.dataset.index = String(i);
          dotsInner.appendChild(dot);
        });
      }
    }
    function moveSlider(slider, index){
      var slides = getSlides(slider);
      var list = getList(slider);
      var track = getTrack(slider);
      if(!slides.length || !list) return false;
      index = Math.max(0, Math.min(index, slides.length - 1));
      slider.setAttribute('data-faetton-arrow-index', String(index));
      try { if(slider.splide && typeof slider.splide.go === 'function') { slider.splide.go(index); updateDots(slider, index); return true; } } catch(e) {}
      if(list.classList.contains('slider-container')){
        try { list.scrollTo({ left: slides[index].offsetLeft || 0, behavior: 'smooth' }); }
        catch(e){ list.scrollLeft = slides[index].offsetLeft || 0; }
        updateDots(slider, index);
        return true;
      }
      var width = (track && track.clientWidth) || slider.clientWidth || (slides[0] && slides[0].getBoundingClientRect().width) || 1;
      slides.forEach(function(slide){ slide.style.flex = '0 0 100%'; slide.style.maxWidth = '100%'; });
      list.style.display = 'flex';
      list.style.overflow = 'visible';
      list.style.transition = 'transform .24s ease';
      list.style.transform = 'translate3d(' + (-(width * index)) + 'px,0,0)';
      updateDots(slider, index);
      return true;
    }
    function moveToImage(scope, imageUrl){
      if(!imageUrl) return false;
      var targetNorm = normUrl(imageUrl), targetBase = fileBase(imageUrl);
      var moved = false;
      getSliders(scope).forEach(function(slider){
        ensureDots(slider);
        var slides = getSlides(slider);
        var found = -1;
        slides.forEach(function(slide, i){
          if(found !== -1) return;
          var img = slide.querySelector('img');
          if(!img) return;
          var candidates = [img.currentSrc, img.src, img.getAttribute('src'), img.getAttribute('data-src'), img.getAttribute('srcset')].filter(Boolean).join(' ');
          var n = normUrl(candidates), b = fileBase(candidates);
          if((targetNorm && n && (n.indexOf(targetNorm) !== -1 || targetNorm.indexOf(n) !== -1)) ||
             (targetBase && b && (b.indexOf(targetBase) !== -1 || targetBase.indexOf(b) !== -1))) found = i;
        });
        if(found === -1 && slides[0]){
          // Fallback: if the exact variant image is not part of the product image list, replace first slide.
          var firstImg = slides[0].querySelector('img');
          if(firstImg){
            firstImg.src = imageUrl;
            if(firstImg.srcset) firstImg.removeAttribute('srcset');
            found = 0;
          }
        }
        if(found !== -1) moved = moveSlider(slider, found) || moved;
      });
      return moved;
    }
    function variantFromForm(form){
      if(!form) return null;
      var jsonEl = form.querySelector('script[class^="prodJson-"], script[class*=" prodJson-"], script[type="application/json"].product-json, script[type="application/json"]');
      if(!jsonEl) return null;
      var product;
      try { product = JSON.parse(jsonEl.textContent || jsonEl.innerHTML || '{}'); } catch(e){ return null; }
      if(!product || !product.variants) return null;
      var opts = qsa(form, '.optionselect').map(function(sel){ return sel.value; });
      var hiddenId = form.querySelector('input[name="id"], #prod-id');
      var id = hiddenId && hiddenId.value;
      var variant = null;
      if(id) variant = product.variants.find(function(v){ return String(v.id) === String(id); });
      if(!variant && opts.length) variant = product.variants.find(function(v){
        return (!opts[0] || v.option1 === opts[0]) && (!opts[1] || v.option2 === opts[1]) && (!opts[2] || v.option3 === opts[2]);
      });
      return variant;
    }
    function imageFromVariant(variant){
      if(!variant) return '';
      if(variant.featured_image){
        if(typeof variant.featured_image === 'string') return variant.featured_image;
        if(variant.featured_image.src) return variant.featured_image.src;
      }
      if(variant.image) return variant.image.src || variant.image;
      return '';
    }
    function syncFromElement(el){
      var scope = findSliderScope(el);
      var form = closest(el, 'form');
      var imageUrl = el && el.getAttribute && (el.getAttribute('data-variantid') || el.getAttribute('data-image') || el.getAttribute('data-img'));
      if(!imageUrl){
        var variant = variantFromForm(form);
        imageUrl = imageFromVariant(variant);
      }
      if(imageUrl) moveToImage(scope, imageUrl);
    }
    function setSwatchActive(el){
      if(!el) return;
      var label = null, input = null;
      if(el.matches && el.matches('input')){ input = el; label = el.id ? doc.querySelector('label[for="' + el.id.replace(/"/g,'\\"') + '"]') : null; }
      else { label = closest(el, 'label') || closest(el, '.color-box') || el; if(label && label.getAttribute && label.getAttribute('for')) input = doc.getElementById(label.getAttribute('for')); }
      if(input && (input.type === 'radio' || input.type === 'checkbox')) input.checked = true;
      var group = closest(label || input, '.customswatch-wrap, .swatch, .option, .selector-wrapper, fieldset, .variant-option') || closest(label || input, 'form');
      if(group){
        qsa(group, 'label, .color-box').forEach(function(node){ node.classList.remove('active','is-active','selected'); node.setAttribute('aria-checked','false'); });
      }
      [label, input && input.parentElement].forEach(function(node){ if(node){ node.classList.add('active','is-active','selected'); node.setAttribute('aria-checked','true'); } });
    }

    doc.addEventListener('change', function(e){
      var el = e.target;
      if(!el || !closest(el, '.flyout-section, .upsell-popup')) return;
      if(el.matches('.customswatch-wrap input, .optionselect, select')) { setSwatchActive(el); setTimeout(function(){ syncFromElement(el); setSwatchActive(el); }, 80); }
    }, true);
    doc.addEventListener('click', function(e){
      var lab = closest(e.target, '.flyout-section .customswatch-wrap label, .upsell-popup .customswatch-wrap label, .flyout-section .color-box, .upsell-popup .color-box, .dots-inner .dot');
      if(!lab) return;
      if(lab.classList.contains('dot')){
        var slider = closest(lab, '.image-slider, [id^="quick-add-slider"]');
        var idx = parseInt(lab.dataset.index || Array.prototype.indexOf.call(lab.parentNode.children, lab), 10);
        if(slider && !isNaN(idx)) { setTimeout(function(){ moveSlider(slider, idx); }, 0); }
        return;
      }
      setTimeout(function(){
        var input = lab.querySelector && lab.querySelector('input');
        if(!input && lab.getAttribute && lab.getAttribute('for')) input = doc.getElementById(lab.getAttribute('for'));
        setSwatchActive(input || lab); syncFromElement(input || lab);
      }, 120);
    }, true);

    // Product-page upsell horizontal dots: create/update dots for .upsell-mprod scroll lists.
    function initUpsellMprodDots(){
      qsa(doc, '.upsell-mprod .upsell-list-scroll').forEach(function(list){
        var items = qsa(list, 'li:not(.hide)');
        if(items.length < 2) return;
        var wrap = closest(list, '.upsell-mprod');
        if(!wrap) return;
        var dots = wrap.querySelector(':scope > .faetton-upsell-scroll-dots');
        if(!dots){
          dots = doc.createElement('div');
          dots.className = 'faetton-upsell-scroll-dots';
          list.insertAdjacentElement('afterend', dots);
        }
        dots.innerHTML = '';
        items.forEach(function(_, i){
          var dot = doc.createElement('span');
          dot.className = 'dot' + (i === 0 ? ' active' : '');
          dot.dataset.index = String(i);
          dots.appendChild(dot);
        });
        function update(){
          var best = 0, dist = Infinity;
          items.forEach(function(item, i){
            var d = Math.abs((item.offsetLeft || 0) - (list.scrollLeft || 0));
            if(d < dist){ dist = d; best = i; }
          });
          qsa(dots, '.dot').forEach(function(dot, i){ dot.classList.toggle('active', i === best); });
        }
        list.addEventListener('scroll', function(){ win.requestAnimationFrame(update); }, {passive:true});
        dots.addEventListener('click', function(e){
          var dot = closest(e.target, '.dot'); if(!dot) return;
          var idx = parseInt(dot.dataset.index || '0', 10);
          if(items[idx]) { try{ list.scrollTo({left: items[idx].offsetLeft || 0, behavior:'smooth'}); }catch(err){ list.scrollLeft = items[idx].offsetLeft || 0; } }
        });
        update();
      });
    }
    if(doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', initUpsellMprodDots, {once:true}); else initUpsellMprodDots();
    doc.addEventListener('faetton:reinit', initUpsellMprodDots);
    win.addEventListener('resize', initUpsellMprodDots, {passive:true});
  })();
})();
